import script from "./TransactionPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransactionPage.vue?vue&type=script&setup=true&lang=ts"

import "./TransactionPage.vue?vue&type=style&index=0&id=1c00ba22&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c00ba22"]])

export default __exports__